const Filters = () => {
  const filtersWrappper = document.querySelector(".cards-grid__filters-wrapper");

  if (filtersWrappper) {
    const opener = filtersWrappper.querySelector(".cards-grid__filters-opener");
    const desktopOpener = filtersWrappper.querySelector(".cards-grid__filters-opener-desktop");
    const filtersList = filtersWrappper.querySelector(".cards-grid__filters-btns");

    if (filtersList.scrollHeight <= 48) {
      desktopOpener.classList.remove("visible");
    } else {
      desktopOpener.classList.add("visible");
    }

    if (desktopOpener) {
      desktopOpener.addEventListener("click", () => {
        filtersList.classList.toggle("opened");

        desktopOpener.innerHTML = filtersList.classList.contains("opened") ? "hide filters" : "See all filters";
      });
    }
    
    opener.addEventListener("click", () => {
      filtersWrappper.classList.toggle("opened");
    });
  }
}

export default Filters